import { Injectable } from "@angular/core";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { BehaviorSubject } from "rxjs";
import { MainService } from "../main/main.service";
import { setTimeout } from "timers";
import { timer } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MessagingService {
  currentMessage = new BehaviorSubject(null);
  constructor(
    private afMessaging: AngularFireMessaging,
    private mainService: MainService
  ) {}

  requestPermission() {
    this.afMessaging.requestPermission.pipe().subscribe(
      () => {
        console.log("Permission granted!");
        const delayedTimer = timer(4000);
        delayedTimer.subscribe(() => {
          this.getToken();
        });
        // setTimeout(() => {
        //   this.getToken();
        // }, 4000);
      },
      (error) => {
        console.error("Permission denied", error);
      }
    );
  }

  getToken() {
    // setTimeout(() => {

    // }, 3000);

    this.afMessaging.getToken.pipe().subscribe(
      (token) => {
        console.log("Token received:", token);
        localStorage.setItem("fcmToken", token);
        this.mainService.changeData(token);
      },
      (error) => {
        // window.location.reload();
        const delayedTimer = timer(1000);
        delayedTimer.subscribe(() => {
          this.requestPermission();
        });
        console.error("Error getting token", error);
      }
    );
  }

  receiveMessage() {
    this.afMessaging.messages.subscribe((payload) => {
      console.log("New message received: ", payload);

      this.currentMessage.next(payload);
    });
  }
}
